<form *ngIf="!isNgModel" [formGroup]="parentForm">
  <p-datepicker [formControlName]="parentControl"
                dateFormat="dd/mm/yy"
                placeholder="{{placeHolder || 'Izaberi datum'}}"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [showOnFocus]="true"
                [disabled]="isDisabled"
                [showButtonBar]="true"
                [appendTo]="'body'"
  ></p-datepicker>
</form>

<ng-container *ngIf="isNgModel">
  <p-datepicker [(ngModel)]="value"
                [ngModelOptions]="{standalone: true}"
                dateFormat="dd/mm/yy"
                [placeholder]="placeHolder || 'Izaberi datum'"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [showOnFocus]="true"
                [disabled]="isDisabled"
                [showButtonBar]="true"
                [appendTo]="'body'"
                (ngModelChange)="onDateChange($event)">
  </p-datepicker>
</ng-container>
